import React from "react";
import { useSettings } from "../context/SettingsContext";

/**
 * Bande d'annonce défilante, visible sur toutes les pages tant que
 * l'administrateur l'a activée (Paramètres > Bande d'annonce).
 */
export default function AnnouncementBar() {
  const { settings } = useSettings();

  if (!settings.bannerActive || !settings.bannerText?.trim()) return null;

  return (
    <div style={{
      background: "var(--brand-secondary, #B8933A)",
      color: "#1A1A1A",
      overflow: "hidden",
      position: "relative",
      height: 34,
      display: "flex",
      alignItems: "center",
      fontSize: 13,
      fontWeight: 600,
    }}>
      <style>{`
        @keyframes setrag-ticker { from { transform: translateX(100%); } to { transform: translateX(-100%); } }
        .setrag-ticker-track { display: inline-block; white-space: nowrap; animation: setrag-ticker 22s linear infinite; padding-left: 100%; }
      `}</style>
      <div className="setrag-ticker-track">
        📢 &nbsp;{settings.bannerText}&nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;&nbsp;📢 &nbsp;{settings.bannerText}
      </div>
    </div>
  );
}
